<template>
    <div
        class="running-as-different-user flex-row-with-gap"
        :style="style"
        ref="draggableElement"
        v-tooltip.left="'You are currently running as a different user. Click the button to revert to your own account.'"
    >
        <div class="draggable-handle">
            <font-awesome-icon :icon="['fas', 'up-down-left-right']" />
        </div>
        <prime-button class="stop-running-as-different-user" @click="emit('stop')">
            Revert to self
        </prime-button>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useDraggable } from '@vueuse/core';
import PrimeButton from 'primevue/button';

const emit = defineEmits<{
    stop: [];
}>();

const draggableElement = ref<HTMLElement | null>(null);

const { style } = useDraggable(draggableElement, {
    initialValue: {
        x: typeof window === 'undefined' ? 0 : window.innerWidth - 200,
        y: typeof window === 'undefined' ? 0 : window.innerHeight - 100,
    },
    preventDefault: true,
});
</script>

<style scoped lang="scss">
.running-as-different-user {
    position: fixed;
    border-radius: var(--borderRadiusOuter);
    gap: 0;
    background-color: var(--neutral100);
    padding: var(--smallSpacing);
    z-index: 10000;
    max-width: 500px;

    .draggable-handle {
        cursor: move;
        padding: var(--defaultSpacing);
    }
}
</style>
